import { useOrderAdjustmentsReportListFilterFields } from 'pages/OrderAdjustmentsReport/hooks/useOrderAdjustmentsReportListFilterFields';
import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

export const OrderAdjustmentsReportListFilterChips: React.FC = () => {
  const fields = useOrderAdjustmentsReportListFilterFields();

  return <FilterChips fields={fields} />;
};
